// extracted by mini-css-extract-plugin
export default {"tableRow":"LostDamagedPalletReportsTableItem_tableRow__Sc1V8","tableRowWithTopFreeSpace":"LostDamagedPalletReportsTableItem_tableRowWithTopFreeSpace__lxdwH"};